export const dataCorrelationUtils = {
  mergeReportData: (classificationData, allPracticeAreaReports, selectedPracticeArea) => {
    return allPracticeAreaReports.map(practiceReport => {
      const allQuarters = extractQuarterInfo(classificationData, practiceReport);
      const quarterBounds = findQuarterBounds(allQuarters);

      if (!quarterBounds) {
        return {
          practiceInfo: buildPracticeInfo(selectedPracticeArea, practiceReport),
          practiceGroupLevel: practiceReport.practiceGroupLevel,
          numberWithinLevel: practiceReport.numberWithinLevel,
          practiceDescription: practiceReport.description,
          metricCalculationName: classificationData.metricCalculationName,
          quarterlyAverages: []
        };
      }

      const { minYear, minQuarter, maxYear, maxQuarter } = quarterBounds;
      const { classificationMap, practiceMap } = createDataMaps(classificationData, practiceReport);

      const quarterRange = generateQuarterRange(minYear, minQuarter, maxYear, maxQuarter);

      const quarterlyAverages = quarterRange.map(quarter => ({
        quarter: quarter.displayName,
        average: classificationMap.get(quarter.displayName) || null,
        practice: practiceMap.get(quarter.displayName) || null
      }));

      return {
        practiceInfo: buildPracticeInfo(selectedPracticeArea, practiceReport),
        practiceGroupLevel: practiceReport.practiceGroupLevel,
        numberWithinLevel: practiceReport.numberWithinLevel,
        practiceDescription: practiceReport.description,
        metricCalculationName: classificationData.metricCalculationName,
        quarterlyAverages
      };
    });
  }
};

const generateQuarterRange = (minYear, minQuarter, maxYear, maxQuarter) => {
  const quarters = [];
  let currentYear = minYear;
  let currentQuarter = minQuarter;

  while (currentYear < maxYear || (currentYear === maxYear && currentQuarter <= maxQuarter)) {
    quarters.push({
      year: currentYear,
      quarterNum: currentQuarter,
      displayName: `${currentYear} Q${currentQuarter}`
    });

    currentQuarter++;
    if (currentQuarter > 4) {
      currentQuarter = 1;
      currentYear++;
    }
  }

  return quarters;
};

const extractQuarterInfo = (classificationData, practiceReport) => {
  const classificationQuarters = classificationData.quarterlyAverages.map(item => ({
    year: item.quarter.year,
    quarter: item.quarter.quarterNum
  }));

  const practiceQuarters = practiceReport.quarterlyData.map(item => ({
    year: item.quarter.year,
    quarter: item.quarter.quarterNum
  }));

  return [...classificationQuarters, ...practiceQuarters];
};

const findQuarterBounds = allQuarters => {
  if (!allQuarters || allQuarters.length === 0) {
    return null;
  }

  const years = allQuarters.map(q => q.year);
  const minYear = Math.min(...years);
  const maxYear = Math.max(...years);

  const minYearQuarters = allQuarters.filter(q => q.year === minYear).map(q => q.quarter);

  const maxYearQuarters = allQuarters.filter(q => q.year === maxYear).map(q => q.quarter);

  const minQuarter = Math.min(...minYearQuarters);
  const maxQuarter = Math.max(...maxYearQuarters);

  return { minYear, minQuarter, maxYear, maxQuarter };
};

const createDataMaps = (classificationData, practiceReport) => {
  const classificationMap = new Map(
    classificationData.quarterlyAverages.map(item => [item.quarter.displayName, item.average])
  );

  const practiceMap = new Map(
    practiceReport.quarterlyData.map(item => [item.quarter.displayName, item.average])
  );

  return { classificationMap, practiceMap };
};

const buildPracticeInfo = (selectedPracticeArea, practiceReport) => {
  return `${selectedPracticeArea.Acronym} ${practiceReport.practiceGroupLevel}.${practiceReport.numberWithinLevel}`;
};
